import cx from 'clsx';

import { getBackgroundComplianceColor } from '../helpers/compliance';
import { ComplianceStatus } from '../types';
import { getComplianceStatusText } from '../views/practice/dentalenhancements/utils';
import { LightTooltip } from '../views/practice/dentalenhancements/components/ToolTip';

const CompliancePlipLight = ({
  status,
  className,
  large,
  medium,
  message
}: {
  status: ComplianceStatus;
  className?: string;
  large?: boolean;
  medium?: boolean;
  message?: string;
}) => {
  return (
    <LightTooltip
      title={message ?? getComplianceStatusText(status)}
      placement="top"
      arrow={true}
      disableInteractive
    >
      <span
        className={cx(
          `compliance-circle`,
          getBackgroundComplianceColor(status),
          { ['compliance-circle__large']: large, ['compliance-circle__medium']: medium },
          className
        )}
      />
    </LightTooltip>
  );
};

export default CompliancePlipLight;
